import { Text, type TextProps } from '@react-three/drei'
import { type PropsWithChildren, useMemo, useState } from 'react'
import * as THREE from 'three'

export function MyText(props: TextProps) {
  return <Text font='/fonts/Ubuntu-Regular.ttf' {...props} />
}

interface TextWithLabelProps extends PropsWithChildren {
  position: [number, number, number]
}

export function TextWithLabel({ children, position }: TextWithLabelProps) {
  const [bgSize, setBgSize] = useState<{width: number; height: number} | undefined>(undefined)

  const shape = useMemo(() => {
    if (!bgSize) return undefined

    const s = new THREE.Shape()
    const r = (bgSize.height / 2) + 0.1
    const w = (bgSize.width - bgSize.height) + 0.1

    s.absarc(w / 2, 0, r, -Math.PI / 2, Math.PI / 2, false)
    s.absarc(-w / 2, 0, r, Math.PI / 2, -Math.PI / 2, false)

    return s
  }, [bgSize])

  return (
    <group position={position}>
      <MyText
        color="black"
        fontSize={0.25}
        anchorX="center"
        anchorY="middle"
        position={[0, 0, 0.01]}

        onSync={(troika) => {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          const width = troika.geometry.boundingBox.max.x - troika.geometry.boundingBox.min.x
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          const height = troika.geometry.boundingBox.max.y - troika.geometry.boundingBox.min.y

          setBgSize({ width, height })
        }}
      >
        {children}
      </MyText>

      {shape && (
        <mesh>
          <shapeGeometry args={[shape]} />
          <meshBasicMaterial color="#fff" />
        </mesh>
      )}
    </group>
  )
}